import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'; // for using ngModel directive
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { DialogModule } from 'primeng/dialog';

import { HisSharedModule } from 'hisng';

import { WebTimeComponent } from './component/webtime/webtime.component';
import { WebTimePageComponent } from './component/webtime/webtime-page.component';
import { WebTimePortletComponent } from './component/webtime/webtime-portlet.component';

/**
 * SharedModule for timemanagement.
 */
@NgModule( {
    imports: [
        // Angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,

        // PrimeNG
        DialogModule,

        // HIS
        HisSharedModule
    ],

    declarations: [
        WebTimeComponent,
        WebTimePageComponent,
        WebTimePortletComponent
    ],

    exports: [
        WebTimeComponent,
        WebTimePageComponent,
        WebTimePortletComponent
    ]

    // NO PROVIDERS! Providers need to go into TimeManagementCoreModule
} )
export class TimeManagementSharedModule {
}
